import { useSyncExternalStore } from 'react';
import { getBrowserTimeZone } from '@/app/_shared/utils';
const noSubscribe = () => () => {};

/** The browser's IANA zone name. Empty on the server and during hydration. */
export function useBrowserTimeZone() {
  return useSyncExternalStore(noSubscribe, getBrowserTimeZone, _temp);
}
function _temp() {
  return "";
}